exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-051328a0]{width:30%;margin:auto;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.title[data-v-051328a0]{font-size:14px;margin:20px 0}.description[data-v-051328a0]{color:#5b6981;margin-bottom:20px}[data-v-051328a0] .btn-link{color:#4d7cfe!important}", ""]);

// exports
